var _g, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6179 9.78859L13.4795 9.53632C14.2859 9.30019 15.1483 9.68226 15.4939 10.4288L16.1819 11.916C16.4819 12.5635 16.3155 13.3255 15.7707 13.7992L14.2563 15.1177C14.3499 15.9068 14.6387 16.6834 15.1235 17.4475C15.5842 18.1869 16.202 18.834 16.9403 19.3505L18.7611 18.7932C19.4507 18.5827 20.2019 18.8255 20.6251 19.3953L21.6107 20.7226C22.1035 21.3855 22.0147 22.2993 21.4043 22.861L20.7499 23.4631C20.0987 24.0622 19.1691 24.28 18.3083 24.0336C16.2771 23.4528 14.4099 21.7287 12.7059 18.8614C10.9995 15.9897 10.3979 13.5521 10.8995 11.5515C11.1107 10.7097 11.7651 10.0387 12.6195 9.78859H12.6179Z",
    fill: "#886CC0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#886CC0",
    fillOpacity: 0.12
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.55e2e082372a70f9dd9ed40e724435d5.svg";
export { ForwardRef as ReactComponent };